/** --------------------------------------------------
* 
*   THEME SCRIPT
*
*   TABLE OF CONTENTS
*   document ready
*
*  -------------------------------------------------- */

(function($) {

  "use strict";

  /** --------------------------------------------------
  *   #document ready
  *   -------------------------------------------------- */

  $(function() {
  });




})(jQuery);
